import React from 'react';
import PropTypes from 'prop-types';

import AccessibleIcon from '../common/AccessibleIcon';

/*  Controlled/Uncontrolled usage:
        - Controlled: onChange + value
        - Uncontrolled: inputRef
*/

const propTypes = {
    className: PropTypes.string,
    inputId: PropTypes.string.isRequired,
    inputType: PropTypes.string,
    inputClassName: PropTypes.string,
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    onKeyDown: PropTypes.func,
    value: PropTypes.string,
    showIconSmallRes: PropTypes.bool, // bootstrap xs resolution will replace label with fa icon specified by props.icon
    inputRef: PropTypes.object,
    children: PropTypes.node,
    srInstructionText: PropTypes.string, // screen reader instructional text
};

const defaultProps = {
    className: '',
    inputType: 'text',
    inputClassName: '',
    onChange: null,
    onKeyDown: null,
    value: null,
    showIconSmallRes: false,
    inputRef: undefined,
    children: null,
    srInstructionText: '',
};

function FilterBox(props) {
    const inputProps = {
        id: props.inputId,
        type: props.type,
        className: "margin-left-sm " + props.inputClassName,
    }

    if (typeof props.value === 'string') inputProps.value = props.value;
    if (typeof props.onChange === 'function') inputProps.onChange = props.onChange;
    if (typeof props.onKeyDown === 'function') inputProps.onKeyDown = props.onKeyDown;
    if (typeof props.inputRef === 'object') inputProps.ref = props.inputRef;
    
    let instructionsId = props.srInstructionText ? `${props.inputId}-filterInstructions` : '';
    if (!!instructionsId) {
        inputProps['aria-describedby'] = instructionsId; // only use this attribute when defined (HEAZ-7389)
    }

    return (
        <div className={`filterBox ${props.className}`}>
            <label htmlFor={props.inputId}>
                {(props.showIconSmallRes) ?
                    <span>
                        <span className="d-none d-sm-inline">{props.label}</span>
                        <AccessibleIcon className={`d-inline-block d-sm-none ${props.icon}`} label={props.label} />
                    </span>
                    :
                    props.label
                }
            </label>
            { props.srInstructionText ?
            <span className="sr-only" id={instructionsId}>{props.srInstructionText}</span>
            : null }
            <input {...inputProps} />
            {props.children}
        </div>
    );
}

FilterBox.propTypes = propTypes;
FilterBox.defaultProps = defaultProps;

export default FilterBox;